<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Invalid Document</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <table>
      <tr>
        <td class="pr-3">Document Name:</td>
        <td>{{ invalidDocument.document_name }}</td>
      </tr>
      <tr>
        <td class="pr-3">Document Completed At:</td>
        <td>
          {{ timeStringFromISO8601(invalidDocument.document_completed_at) }},
          {{ dateStringFromISO8601(invalidDocument.document_completed_at) }}
        </td>
      </tr>
      <tr>
        <td class="pr-3">Document PDF:</td>
        <td>
          <a [href]="invalidDocument.document_pdf" target="_blank">Link</a>
        </td>
      </tr>
      <ng-container *ngFor="let relatedCustomer of invalidDocument.related_customers">
        <tr style="height: 10px;"></tr>
        <tr>
          <td class="pr-3">Customer Name:</td>
          <td>
            <a [routerLink]="['/customers', relatedCustomer.id.toString()]" target="_blank">
              {{ relatedCustomer.first_name }} {{ relatedCustomer.last_name }}
            </a>
          </td>
        </tr>
        <tr>
          <td class="pr-3">Birthday:</td>
          <td>{{ dateStringFromISO8601(relatedCustomer.birthday) }}</td>
        </tr>
        <tr>
          <td class="pr-3">Email Address:</td>
          <td *ngIf="relatedCustomer.email">{{ relatedCustomer.email }}</td>
          <td *ngIf="!relatedCustomer.email" class="text-muted">None given</td>
        </tr>
        <tr>
          <td class="pr-3">Telephone:</td>
          <td *ngIf="relatedCustomer.telephone">{{ relatedCustomer.telephone }}</td>
          <td *ngIf="!relatedCustomer.telephone" class="text-muted">None given</td>
        </tr>
      </ng-container>
    </table>

    <div class="form-check mt-4">
      <input class="form-check-input" type="radio" id="dismissInput"
             [value]="InvalidDocumentAction.dismiss" [(ngModel)]="selectedAction">
      <label class="form-check-label" for="dismissInput">
        Dismiss inbox item
      </label>
    </div>

    <div class="alert alert-danger mb-0 mt-3" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

  </div>

  <div class="modal-footer">

    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary"
            *ngIf="!loadingSubmit"
            (click)="handleSave()"
            [disabled]="!validInputSelected()"
            [class.disabled]="!validInputSelected()">
      Save
    </button>
    <button type="button" class="btn btn-primary disabled" disabled
            *ngIf="loadingSubmit">
      Loading...
    </button>

  </div>

</ng-container>
